<template>
    <v-dialog v-model="showDialog"
              class="create-day-task-dialog"
              min-width="300"
              width="600"
              transition="dialog-bottom-transition">
        <v-card class="date-time-form text-primary ma-0">
            <v-card-title class="mb-4">
                Создание задачи
            </v-card-title>

            <v-card-text class="pa-4 pt-0">
                <v-card class="text-primary ma-0 mb-4"
                        @click="editDateAndTime = true"
                        variant="outlined">
                    <v-card-title class="d-flex justify-center">
                        {{getDate(dateAndTime.date)}}
                    </v-card-title>
                </v-card>

                <TimeCard class="ma-0 mb-4"
                          :startTime="dateAndTime.startTime"
                          :endTime="dateAndTime.endTime"
                          :duration="dateAndTime.duration"
                          alternative-text="Время не задано"
                          width="auto"
                          @click="editDateAndTime = true" />

                <v-row align="center" class="mb-2">
                    <v-col>
                        <v-textarea class="ma-0 mb-n8"
                                    label="Название задачи"
                                    auto-grow
                                    rows="1"
                                    v-model="taskText"></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="5" md="4" class="text-right mb-n3">
                        <v-btn v-if="showRegenerateButton"
                               color="secondary"
                               variant="elevated"
                               class="mr-0 ml-auto"
                               @click="$emit('regenerate:dayTask')">Перегенерировать</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions class="pt-0 pr-4 pb-4">
                <v-spacer />
                <v-btn color="secondary"
                       variant="elevated"
                       @click="$emit('hide')">Отменить</v-btn>                
                <v-btn color="primary"
                       variant="elevated"
                       :disabled="!dateAndTime.date || !taskText"
                       @click="save">Сохранить</v-btn>
            </v-card-actions>
        </v-card>

        <DateTimeDialog v-if="editDateAndTime"
                        @hide="editDateAndTime = false"
                        v-model="dateAndTime"
                        :min="minDate"
                        :max="maxDate" />
    </v-dialog>
</template>

<script>
    import TimeCard from "@/components/TimeCard.vue";
    import DateTimeDialog from "@/components/DateTimeDialog.vue";

    export default {
        components: {
            TimeCard,
            DateTimeDialog
        },

        props: {
            date: Object,
            text: String,
            minDate: Object,
            maxDate: Object,
            showRegenerateButton: Boolean
        },

        emits: ["create:dayTask", "regenerate:dayTask", "hide"],

        data() {
            return {
                showDialog: true,
                editDateAndTime: false,

                id: 0,
                taskText: this.text ?? "",
                isCompleted: null,
                resultText: "",
                dateAndTime: {
                    date: this.date ?? null,
                    startTime: "",
                    duration: "",
                    endTime: "",
                    taskNumber: null
                }
            };
        },

        computed: {
            currentLocale() {
                return this.$store.state.currentLocale;
            }
        },

        watch: {
            showDialog(newValue) {
                if (newValue === false) {
                    this.$emit("hide");
                }
            },

            text(newValue) {
                this.taskText = newValue;
            }
        },

        methods: {
            getDate(dateTime) {
                if (!dateTime) {
                    return "Дата не задана";
                }

                return dateTime.setLocale(this.currentLocale).toFormat("d MMMM (EEEE)");
            },

            save() {
                if (!this.dateAndTime?.date || !this.taskText) {
                    return;
                }

                const newTask = {
                    id: this.id,
                    taskText: this.taskText,
                    isCompleted: this.isCompleted,
                    resultText: this.resultText,
                    dateAndTime: this.dateAndTime
                };

                this.$emit("hide");
                this.$emit("create:dayTask", newTask);
            }
        }
    };
</script>

<style lang="scss">
    .create-day-task-dialog {
    }
</style>